import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as $ from 'jquery';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: ['./preguntas-frecuentes.component.css']
})
export class PreguntasFrecuentesComponent implements OnInit {
  idPregunta: string;
  idTab: string;

  constructor(private titleService: Title, private router: ActivatedRoute) { }
  ngOnInit() {
    // Para obtener el parametro de la url
    this.router.params.subscribe(params => {
      this.idPregunta = params['idPregunta'];
      this.idTab = params['idSeccion'];
    });

    // $(document).ready(function () {
    //   $('.active-INE').removeClass('active-INE');
    //   $("#Preguntasfrecuentes").closest('.nav-item').find("a").addClass('active-INE');
    //   $("#main").removeClass("m-main-menu");
    //   $(".subrayado").removeClass("subrayado");
    // });
    $('#Preguntasfrecuentes').click(
      function () {
        $('html,body').animate({ scrollTop: '0px' }, 500);
        return false;
      }
    );
    this.titleService.setTitle('Preguntas Frecuentes | CentroAyuda Cómputos');
  }
  ngAfterViewInit() {
    this.loadComponent();
  }

  loadComponent() {
    if (this.idPregunta == "principal") {
      $('html,body').animate({ scrollTop: '0px' }, 500);
    }
    else {
      // Desactivar tab
      $(".nav-link").removeClass("active");
      $('.tab-pane').removeClass('active');
      $('.tab-pane').removeClass('show');
      // Activar clases al seleccionado
      // tab
      $('#' + this.idTab.toString() + '-tab.nav-link').addClass('active');
      $('#' + this.idTab.toString() + '.tab-pane').addClass('active');
      $('#' + this.idTab.toString() + '.tab-pane').addClass('show');
      $('[aria-controls=' + this.idTab.toString() + '-tab]').attr("aria-selected", "true");
      // pregunta
      $(".acordion").attr("aria-expanded", "false");
      $(".collapse").removeClass("show");
      $(".acordion").attr("aria-expanded", "false");
      $('#' + this.idPregunta.toString()).addClass('show');
      $('[aria-controls=' + this.idPregunta.toString() + ']').attr("aria-expanded", "true");
      $('html, body').animate({ scrollTop: $('#' + this.idPregunta.toString()).offset().top - 250 }, 'slow');

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/preguntas-frecuentes/preguntas-frecuentes.component.ts